import { c as _c } from "react/compiler-runtime";
import type { BigIntish } from '@morpho-org/blue-sdk';
import { toBigInt } from '@morpho-org/dapp-core';
import { cn } from '@morpho-org/ui-v6/utils';
import React, { memo, type PropsWithChildren, useMemo } from 'react';
interface LoanToValueCellHealthBarProps extends PropsWithChildren {
  ltv: BigIntish | null | undefined;
  lltv: BigIntish | null | undefined;
  isPositionUnhealthy: boolean;
}
const getPercentage = (ltv: bigint, lltv: bigint): number => {
  if (lltv === 0n) return 0;
  return Number(ltv * 100n / lltv);
};
const LoanToValueCellHealthBar: React.FC<LoanToValueCellHealthBarProps> = t0 => {
  const $ = _c(10);
  const {
    ltv,
    lltv,
    isPositionUnhealthy
  } = t0;
  let t1;
  if ($[0] !== lltv || $[1] !== ltv) {
    bb0: {
      const ltvBigInt = toBigInt(ltv);
      const lltvBigInt = toBigInt(lltv);
      if (!ltvBigInt || !lltvBigInt) {
        t1 = 0;
        break bb0;
      }
      t1 = getPercentage(ltvBigInt, lltvBigInt);
    }
    $[0] = lltv;
    $[1] = ltv;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const percentage = t1;
  let t2;
  if ($[3] !== isPositionUnhealthy) {
    t2 = cn("flex", cn("absolute top-0 left-0 h-full", "transition-[width,background-color] duration-200 ease-in-out", isPositionUnhealthy ? "bg-destructive-foreground" : "bg-info-foreground"));
    $[3] = isPositionUnhealthy;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `${percentage}%`;
  let t4;
  if ($[5] !== t3) {
    t4 = {
      width: t3
    };
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <div className="bg-muted relative flex h-[5px] w-full overflow-hidden"><div className={t2} style={t4} /></div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default memo(LoanToValueCellHealthBar);